import { render, staticRenderFns } from "./healthyScore.vue?vue&type=template&id=5445c7f7&scoped=true&"
import script from "./healthyScore.vue?vue&type=script&lang=js&"
export * from "./healthyScore.vue?vue&type=script&lang=js&"
import style0 from "./healthyScore.vue?vue&type=style&index=0&id=5445c7f7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5445c7f7",
  null
  
)

export default component.exports